import { useTranslation } from 'react-i18next';
import { notify } from '../../../components/ui';
import { useApiError } from '../../../hooks/useApiError';
import api from '../../../services/api';

/**
 * Sold-out switch: updates the screen first, saves, rolls back on failure and offers undo.
 * `apply` writes the new value into the caller's state.
 */
export const useAvailability = (apply: (id: string, isAvailable: boolean) => void) => {
    const { t } = useTranslation('menu');
    const apiError = useApiError();

    const set = async (id: string, name: string, next: boolean, undoable = true): Promise<void> => {
        apply(id, next);
        try {
            await api.put(`/menu-items/${id}/availability`, { isAvailable: next });
            notify.success(
                t(next ? 'availability.on' : 'availability.off', { name }),
                undoable ? { undo: { label: t('availability.undo'), run: () => void set(id, name, !next, false) } } : undefined
            );
        } catch (e) {
            apply(id, !next);
            notify.error(apiError(e));
        }
    };
    return set;
};
